import useStore from '../store'

export default function useUserType() {
  const user = useStore((state) => state.user)

  return {
    isAccountManager: user?.type === 'AccountManager',
    isVCI: user?.type === 'VCI',
    isDealer: user?.type === 'DealerUser',
    isAdmin: user?.type === 'Admin',
    isEmployee: user?.type === 'AccountManager' || user?.type === 'VCI' || user?.type === 'User' || user?.type === 'Admin',
    isLoggedIn: !!user
  }
}